<script>
// import { formatMonto } from "@/utils";

export default {
  name: "HyperlinkProspecting",
  functional: true,
  props: {
    openSelect: {
      type: Function
    },
    row: {
      type: Object
    },
    column: {
      type: String
    },
    rowValue: {
      type: [String, Number, Object, Array, Function],
      require: false
    },
    getType: {
      type: Function,
      require: false
    },
    month: {
      type: Number,
      require: false
    },

    isTotal: {
      type: Boolean,
      default: false
    }
  },

  render(createElement, context) {
    const { isTotal } = context.props;
    let classs = "red";
    function displayValue(props) {
      if (!props.getType) {
        const value = props.row[props.column];

        if (value == "0.00" || value == "0") {
          return "0 %";
        }
        if (value <= 79) {
          classs = "red";
        } else if (value >= 90) {
          classs = "green";
        } else if (value >= 80 && value <= 89) {
          classs = "golden";
        }
        return value.toFixed(2) + " %";
      }
    }

    if (isTotal) {
      return createElement("span", {}, displayValue(context.props));
    }

    return createElement(
      "a",
      {
        attrs: {
          href: "#",
          class: classs
        },
        on: {
          click: () => {
            context.props.openSelect(context.props);
          }
        },
        style: {
          color: ""
        }
      },
      displayValue(context.props)
    );
  }
};
</script>

<style scoped>
.red {
  color: red;
}
.green {
  color: green;
}
.golden {
  color: goldenrod;
}
</style>
